var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',_vm._g(_vm._b({attrs:{"rules":_vm.descriptionRules,"label":"Description","counter":"counter","data-track":"description","dense":"","outlined":""}},'v-textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }